import React from 'react';
import { CheckIcon, HourglassIcon, RotateCcwIcon, ShieldCheckIcon } from 'lucide-react';
import { OccurrenceStatus } from '../types/activity';
interface StatusBadgeProps {
  status: OccurrenceStatus;
}
const config: Record<Exclude<OccurrenceStatus, 'odprto'>, {
  label: string;
  className: string;
  Icon: typeof CheckIcon;
}> = {
  opravljeno: {
    label: 'Opravljeno',
    className: 'bg-done-soft text-done-ink',
    Icon: CheckIcon
  },
  v_pregledu: {
    label: 'V pregledu',
    className: 'bg-review-soft text-review-ink',
    Icon: HourglassIcon
  },
  popravek: {
    label: 'Popravek',
    className: 'bg-accent-soft text-accent-ink',
    Icon: RotateCcwIcon
  },
  potrjeno: {
    label: 'Potrjeno',
    className: 'bg-done-soft text-done-ink',
    Icon: ShieldCheckIcon
  }
};
export function StatusBadge({
  status
}: StatusBadgeProps) {
  if (status === 'odprto') return null;
  const {
    label,
    className,
    Icon
  } = config[status];
  return <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-bold ${className}`} data-id="element-962" data-mp="c03s3illr75u">
      <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-963" data-mp="2ae4anu8wdmc8" />
      {label}
    </span>;
}